import type { FC } from "react";

import styled from "@emotion/styled";
import translate from "src/lib/translate";
import Meals from "src/ui/components/Meals/Meals";
import InDialog from "src/ui/components/InDialog/InDialog";
import useGoToOrBack from "src/ui/hooks/useGoToOrBack";

import { AppQueryPopupsController } from "../AppQueryPopupsBloc";

const MealPlanningInDialog = styled(InDialog)`
  & > * {
    padding-bottom: 0;
  }

  .close {
    width: 2rem;
    height: 2rem;
    padding: 0;
    border-radius: 200px;
    background: rgba(33, 33, 33, 0.12);

    svg {
      width: 1.5rem;
      height: 1.5rem;
      color: #212121;
    }

    svg path {
      fill-opacity: 1;
    }
  }
`;

const MealPlanningDialog: FC<{ returnUrl: string }> = ({ returnUrl }) => {
  const navigate = useGoToOrBack();

  const onClose = () => {
    AppQueryPopupsController.closePopup();
    navigate(returnUrl, { multiBack: true, replace: true });
  };

  return (
    <MealPlanningInDialog
      popup
      isFullScreen
      noPadding
      title={translate("mealInsights.mealPlanner.title")}
      onClose={onClose}
      returnUrl={returnUrl}
    >
      <Meals />
    </MealPlanningInDialog>
  );
};

export default MealPlanningDialog;
